import { RouteRecordRaw } from 'vue-router';

export const advertisementRouters: RouteRecordRaw[] = [
  {
    path: '/advertisement',
    name: 'advertisement',
    component: () => import('@/pages/h5/Advertisement/Advertisement.vue'),
    meta: { title: '优客查查', disabledNavBar: true },
  },
  {
    path: '/advertisementOther',
    name: 'advertisementOther',
    component: () => import('@/pages/h5/Advertisement/AdvertisementOther.vue'),
    meta: { title: '你身边的大数据专家', disabledNavBar: true },
  },
  {
    path: '/vipLandingPage',
    name: 'VipLandingPage',
    component: () => import('@/pages/h5/Advertisement/VipLandingPage/index.vue'),
    meta: { title: '会员', disabledNavBar: true },
  },
  {
    path: '/vipLandingPageOther',
    name: 'VipLandingPageOther',
    component: () => import('@/pages/h5/Advertisement/VipLandingPageOther/index.vue'),
    meta: { title: '会员', disabledNavBar: true },
  },
  {
    path: '/vipIncomeOther',
    name: 'VipIncomeOther',
    component: () => import('@/pages/h5/VipCenter/VipIncomeOther/index.vue'),
    meta: { title: '会员收益', disabledNavBar: true },
  },
  // 投诉工单
  {
    path: '/complaintTicket',
    name: 'ComplaintTicket',
    component: () => import('@/pages/h5/ComplaintTicket/ComplaintTicket/index.vue'),
    meta: { title: '填写信息' },
  },
  // 工单小助手
  {
    path: '/workAssistant',
    name: 'WorkAssistant',
    component: () => import('@/pages/h5/ComplaintTicket/WorkAssistant/index.vue'),
    meta: { title: '工单小助手' },
  },
  // 提交成功
  {
    path: '/ticketSuccess',
    name: 'TicketSuccess',
    component: () => import('@/pages/h5/ComplaintTicket/TicketSuccess/index.vue'),
    meta: { title: '提交成功', disabledNavBar: true },
  },
  // 征信报告
  {
    path: '/creditReport',
    name: 'CreditReport',
    component: () => import('@/pages/h5/OtherReport/index.vue'),
    meta: {
      title: '征信报告',
      checkAuth: true,
      disabledNavBar: true,
    },
  },
  // 邀请代理
  // {
  //   path: '/inviteAgentsLanding',
  //   name: 'InviteAgentsLanding',
  //   component: () => import('@/pages/h5/Advertisement/InviteAgentsLandingPage/index.vue'),
  //   meta: { title: '邀请代理', disabledNavBar: true },
  // },
  // 邀请代理
  {
    path: '/inviteAgentsLanding',
    name: 'InviteAgentsLanding',
    component: () => import('@/pages/h5/Advertisement/InviteAgentsLandingPage/index.vue'),
    meta: { title: '邀请代理', disabledNavBar: true },
  },
  // 百行新筛落地页
  // {
  //   path: '/letterSieveLanding',
  //   name: 'LetterSieveLanding',
  //   component: () => import('@/pages/h5/Advertisement/LetterSieveLanding/index.vue'),
  //   meta: { title: '邀请代理', disabledNavBar: true },
  // },
  {
    path: '/retainFunds',
    name: 'RetainFunds',
    component: () => import('@/pages/h5/Advertisement/RetainFunds/index.vue'),
    meta: { title: '留资进件', disabledNavBar: true },
  },
  {
    path: '/apply',
    name: 'Apply',
    component: () => import('@/pages/h5/Advertisement/Apply/index.vue'),
    meta: { title: '留资进件', disabledNavBar: true },
  },
  {
    path: '/vipLandingV2',
    name: 'VipLandingV2',
    component: () => import('@/pages/h5/Advertisement/VipLandingV2/index.vue'),
    meta: { title: '会员', disabledNavBar: true },
  },
  {
    path: '/vipActivity',
    name: 'VipActivity',
    component: () => import('@/pages/h5/Advertisement/VipActivity/index.vue'),
    meta: { title: '会员活动', disabledNavBar: true },
  },
  {
    path: '/viewSharingInfo',
    name: 'ViewSharingInfo',
    component: () => import('@/pages/h5/Advertisement/ViewSharingInfo/index.vue'),
    meta: { title: '内容详情', disabledNavBar: true },
  },
  {
    path: '/productInquiry/:id',
    name: 'ProductInquiry',
    component: () => import('@/pages/h5/Advertisement/ProductInquiry/index.vue'),
    meta: { title: '产品咨询' },
  },
  {
    path: '/customIncoming',
    name: 'CustomIncoming',
    component: () => import('@/pages/h5/Advertisement/CustomIncoming/index.vue'),
    meta: { title: '自定义进件' },
  },
  {
    path: '/loanTool',
    name: 'LoanTool',
    component: () => import('@/pages/h5/ToolPage/loanTool/index.vue'),
    meta: { title: '贷款计算器', disabledNavBar: true },
  },
  {
    // 正则匹配：以 .txt 结尾的路径（支持带前缀的情况）
    path: `/:filename(.*\\.txt)`,
    name: 'MP',
    component: () => import('@/pages/MP_verify.vue'),
    meta: { title: 'MP', disabledNavBar: true },
  },
];
